import React from "react";
import { Controller } from "react-hook-form";
import "./Multicheckbox.css"; // Ensure styles are applied

const CheckboxGroup = ({ options, name, control, parentLabel }) => {
  console.log("Received Parent Label:", parentLabel); // Debugging

  return (
    <div className="checkbox-group-container">
      {parentLabel && <label className="checkbox-parent-label" style={{color:"black"}}>{parentLabel}</label>}
      <div className="checkbox-group div-space-adminrole">
        {options.map((option) => (
          <Controller
            key={`${name}.${option.name}`} // Ensure a unique key
            name={`${name}.${option.name}`} // ✅ Ensure unique name for each checkbox
            control={control}
            render={({ field: { onChange, value } }) => (
              <label className="checkbox-container">
                <span className="dynamic__checkbox--label label-adminrole">{option.label}</span>
                <input
                  className="check-adminrole"
                  type="checkbox"
                  checked={value || false}
                  onChange={(e) => onChange(e.target.checked)}
                />
              </label>
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;
